import { useNavigate } from "react-router-dom";
import { ArrowIcon } from "./right-frame/RightFrameSvgIcons";
import { LMS_WEBAPP_CONFIG_IMPL } from "../../infecto-lms-webapp-impl/config";
import { DASHBOARD_PATH } from "../../infecto-lms-webapp-impl/router/routes/auth/dashboard.routes";

export const GoToDashboardButton = () => {
	const navigate = useNavigate();

	return (
		<div className="w-full flex justify-content-end">
			<div
				className="flex align-items-center justify-content-center"
				onClick={() => navigate(DASHBOARD_PATH)}
			>
				<span className="text-primary cursor-pointer">Zur Startseite</span>
				<ArrowIcon color={LMS_WEBAPP_CONFIG_IMPL.brandColor} />
			</div>
		</div>
	);
};
